const endpoints = {
    getShareClass: '/share_class',
    shareNavPrice: '/share_nav_price',
    getAnnualPerformance : 'share_annual_performance',
    mifl: {
        getProductsList: '/mifl_product_catalogue/',
        getPastPerformance: '/mifl_product_past_performance/',
        getPastPerformanceDates: '/mifl_performance_scenarios_dates/',
        getPastPerformanceScenario: '/mifl_performance_scenarios/',
    },
    mildac: {
        getProductsList: '/mil_product_catalogue/',
        getPastPerformance: '/mil_product_past_performance',
        getPastPerformanceDates: '/mil_performance_scenarios_dates/',
        getPastPerformanceScenario: '/mil_performance_scenarios/',
        getPastPerformanceOptions: '/mil_product_past_performance_options',
    }

}

export default endpoints
